import { createBasketsAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import {
  clearPastOrderAction,
  getPastOrderAction,
  resetOrderAction,
} from '@kfc-global/react-shared/redux/Actions/orderAction';
import { resetPaymentStatus } from '@kfc-global/react-shared/redux/Actions/PaymentsAction';
import {
  cancelPostOrder,
  checkInRequest,
  getPostOrderAccepted,
  resetPostOrder,
  getAddHopeOrderAccepted,
  getGiftCardPurchaseAccepted,
} from '@kfc-global/react-shared/redux/Actions/PostOrderAction';
import { getBulkStoreStatus } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import { getTendersContent } from '@kfc-global/react-shared/redux/Actions/PaymentsContentAction';
import getContentHelpCall from '@kfc-global/react-shared/redux/Actions/HelpAction';
import {
  GET_ORDER_STATUS_MAX_RETRY_COUNT,
  GET_ORDER_STATUS_MAX_RETRY_INTERVAL_MS,
  GET_ORDER_STATUS_MAX_RETRY_DELIVERY_INTERVAL_MS,
} from '@kfc-global/react-shared/config/config.constants';
import { config } from '@kfc-global/react-shared/config/config.utils';

import {
  LOCAL_STORAGE_KEYS,
  PAYMENT_STATUS,
  PURCHASE_TYPE,
  ROUTE_URL,
  SESSION_STORAGE_KEYS,
} from 'common/constants/SharedConstants';
import { ChannelManager } from 'common/manager';
import { updatePurchaseOrderDetailsAnalytics } from 'common/utilities/analyticsUtils';
import { getCmsClient } from 'common/utilities/cmsClient';
import {
  checkByParams,
  dispatchCreateBasketsAction,
  redirectToPaymentFailurePage,
  redirectToHomePage,
  redirectToGiftCardPage,
  isDeliveryOrPickupOrDineInOrCateringDisposition,
  getFullAddressDetails,
  isCateringDisposition,
  redirectToCARTPage,
} from 'common/utilities/utils';

import {
  isFailedOrder,
  isOrderProcessCompleted,
  isStagedOrAcceptedOrder,
  isStagedOrder,
  isValidOrderStatus,
  isCateringOrderAccepted,
  isPickupOrderCancelled,
  isPickupOrderSentPOSCompleted,
  isDeliveryOrderCreate,
  isAddHopePaymentInProcess,
  isCheckRetryCountForGetOrderTrackingStatus,
  isOrderStatusPolling,
  isAddHopePaymentSuccess,
  isAddHopePurchase,
  isGiftCardPurchase,
  isGiftCardPaymentFailure,
  isGiftCardPaymentSuccess,
  isGiftCardPaymentInProcess,
  isAddHopePaymentFailure,
  isSentToPosCompletedOrisReadyPosInjection,
} from 'common/utilities/orderStatusUtils';

import {
  getOrderDetailsFromReducer,
  getUpdatedOrderDetails,
  updateOrderDetailsFromCreateOrderReducer,
} from 'common/utilities/orderDetailsUtils';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';

/*********************************************************************
 * updateOrderDetailsAnalytics
 * params
 * console.debug('updateOrderDetailsAnalytics => ');
 *********************************************************************/
export const updateOrderDetailsAnalytics = params => {
  const { orderDetails, updateSetOrderDetails } = params;
  const sessionStorageOrderTrackingDetails =
    orderDetails?.userStatus?.loggedIn && JSON?.parse(sessionStorage?.getItem(LOCAL_STORAGE_KEYS?.ORDER_TRACKING));
  if (!sessionStorageOrderTrackingDetails) {
    isCateringOrderAccepted(orderDetails) && updatePurchaseOrderDetailsAnalytics({ orderDetails });
    if (
      (isPickupOrderSentPOSCompleted(orderDetails) || isDeliveryOrderCreate(orderDetails)) &&
      !orderDetails?.isAnalyticsUpdated
    ) {
      updatePurchaseOrderDetailsAnalytics({ orderDetails });
      updateSetOrderDetails({ isAnalyticsUpdated: true });
    }
  }
};

/*********************************************************************
 * checkOrderTypeIsGiftCardPurchase
 * props
 * console.debug('checkOrderTypeIsGiftCardPurchase => ');
 *********************************************************************/
export const checkOrderTypeIsGiftCardPurchase = props => {
  if (localStorage.getItem(LOCAL_STORAGE_KEYS.POST_PAYMENT_TYPE) === PURCHASE_TYPE.GIFT_CARD_PURCHASE) {
    localStorage.setItem(LOCAL_STORAGE_KEYS.PAYMENT_STATUS, PAYMENT_STATUS.SUCCESS);
    redirectToGiftCardPage(props);
  }
};

/*********************************************************************
 * updateSetOrderDetailsFromOrderTracking
 * params -
 * console.debug('updateSetOrderDetailsFromOrderTracking => ');
 *********************************************************************/
export const updateSetOrderDetailsFromOrderTracking = params => {
  const sessionStorageOrderTrackingDetails = JSON?.parse(sessionStorage?.getItem(LOCAL_STORAGE_KEYS?.ORDER_TRACKING));
  if (sessionStorageOrderTrackingDetails && Object?.keys(sessionStorageOrderTrackingDetails)?.length) {
    const { dispatch, updateSetOrderDetails } = params;
    if (
      sessionStorageOrderTrackingDetails?.postOrderDetails &&
      Object.keys(sessionStorageOrderTrackingDetails?.postOrderDetails).length === 0
    ) {
      dispatchGetOrderDetailsAction({
        dispatch,
        orderDetails: sessionStorageOrderTrackingDetails,
        updateSetOrderDetails,
      });
    }
  } else {
    triggerGetOrderDetailsAPI(params);
  }
};

/*********************************************************************
 * getDeliveryOrderStatusTracking
 * params
 * console.debug('getDeliveryOrderStatusTracking => ', orderStatus);
 *********************************************************************/
export const getDeliveryOrderStatusTracking = params => {
  const { dispatch, orderDetails, updateSetOrderDetails, miscPaymentReferenceId } = params;

  orderDetails?.tenantId &&
    isCheckRetryCountForGetOrderTrackingStatus(orderDetails) &&
    updateSetOrderDetails({ displayOrderProcessingPage: false });

  if (orderDetails?.orderId && isOrderStatusPolling(orderDetails)) {
    const dispatchDeliveryOrderTrackerTimer = setTimeout(() => {
      orderDetails?.dispatchDeliveryOrderTrackerTimer && clearTimeout(orderDetails?.dispatchDeliveryOrderTrackerTimer);
      updateSetOrderDetails({
        dispatchDeliveryOrderTrackerTimer: dispatchDeliveryOrderTrackerTimer,
      });

      dispatchGetOrderDetailsAction({
        dispatch,
        orderDetails,
        updateSetOrderDetails,
        miscPaymentReferenceId,
      });
    }, config(GET_ORDER_STATUS_MAX_RETRY_DELIVERY_INTERVAL_MS));
  }
};

/*********************************************************************
 * checkInvalidateCart
 * params
 * console.debug('checkInvalidateCart In ==> ', sentToPosCompleted + ' ' + userStatus?.localized);
 *  console.debug('checkInvalidateCart In ==> ', !cartReducer?.isBasketLoading + ' ' + cartReducer?.cartData?.id);
 *********************************************************************/
export const checkInvalidateCart = params => {
  const { dispatch, orderDetails, cartReducer, userOrderState, appStateReducer, updateSetOrderDetails } = params;
  const { service } = orderDetails;
  const sentToPosCompleted =
    ChannelManager?.shouldGoogleSpotIgnoreOloFailure ||
    isSentToPosCompletedOrisReadyPosInjection(orderDetails) ||
    isCateringOrderAccepted(orderDetails);

  if (isDeliveryOrPickupOrDineInOrCateringDisposition(service) && sentToPosCompleted) {
    const userStatus = appStateReducer?.userStatus;

    if (
      checkByParams(
        sentToPosCompleted,
        !cartReducer?.isBasketLoading,
        cartReducer?.cartData?.id,
        userStatus?.localized,
        orderDetails?.tenantId,
      )
    ) {
      updateSetOrderDetails({ isBasketsCreated: true });
      dispatchCreateBasketsAction(dispatch, createBasketsAction, orderDetails?.tenantId, userOrderState);
    }
  }
};

/*********************************************************************
 * triggerGetPostOrderAPI
 * params
 * console.debug('triggerGetPostOrderAPI => ');
 *********************************************************************/
export const triggerGetOrderDetailsAPI = params => {
  const { dispatch, postOrderReducer = {}, orderReducer = {}, orderDetails, updateSetOrderDetails } = params;
  const reducerOrderDetails = getOrderDetailsFromReducer({
    postOrderReducer,
    orderReducer,
    orderDetails,
    isCheckOrderDetails: false,
  });
  const { props, orderId, retryCountForGetOrderStatus, miscPaymentReferenceId, wiCodePurchaseId } = orderDetails;

  if (orderDetails && (orderId || miscPaymentReferenceId || wiCodePurchaseId) && isValidOrderStatus(orderDetails)) {
    if (
      retryCountForGetOrderStatus === 0 ||
      ((isStagedOrAcceptedOrder(reducerOrderDetails) ||
        isAddHopePaymentInProcess(orderDetails) ||
        isGiftCardPaymentInProcess(orderDetails)) &&
        retryCountForGetOrderStatus < config(GET_ORDER_STATUS_MAX_RETRY_COUNT))
    ) {
      dispatchGetOrderDetailsAction({ dispatch, orderDetails, updateSetOrderDetails });
    } else if (
      (isStagedOrAcceptedOrder(reducerOrderDetails) ||
        isAddHopePaymentInProcess(orderDetails) ||
        isGiftCardPaymentInProcess(orderDetails)) &&
      retryCountForGetOrderStatus >= config(GET_ORDER_STATUS_MAX_RETRY_COUNT)
    ) {
      localStorage.setItem(PAYMENT_STATUS.STATUS_TEXT, PAYMENT_STATUS.FAILED);
      redirectToPaymentFailurePage(props);
    }
  } else {
    redirectToHomePage(props);
  }
};

/*********************************************************************
 * dispatchGetOrderDetailsAction
 * params
 * console.debug('dispatchGetOrderDetailsAction => ', orderDetails);
 *********************************************************************/
export const dispatchGetOrderDetailsAction = params => {
  const { dispatch, orderDetails, updateSetOrderDetails = null } = params;

  if (orderDetails?.isExternalTrackOrder) {
    dispatchGetPastOrderAction({ dispatch, orderDetails, updateSetOrderDetails });
  } else {
    if (isAddHopePurchase()) {
      dispatchPostAddHopePayment({ dispatch, orderDetails, updateSetOrderDetails });
    } else if (isGiftCardPurchase()) {
      dispatchPostGiftCardPayment({ dispatch, orderDetails, updateSetOrderDetails });
    } else {
      dispatchGetPostOrderAccepted({ dispatch, orderDetails, updateSetOrderDetails });
    }
  }
};

/*********************************************************************
 * dispatchGetPastOrderAction
 * params
 * console.debug('dispatchGetPastOrderAction => ', orderDetails);
 *********************************************************************/
export const dispatchGetPastOrderAction = params => {
  const { dispatch, orderDetails, updateSetOrderDetails = null } = params;

  const request = {
    emailId: orderDetails?.userEmail,
    phoneNo: orderDetails?.userPhone,
    orderNo: orderDetails?.posOrderId,
    tenantId: orderDetails?.tenantId,
  };
  const count = orderDetails?.retryCountForGetOrderStatus + 1;
  dispatch(getPastOrderAction(request, () => getOrderDetailsSuccessCallback({ count, updateSetOrderDetails })));
};

/*********************************************************************
 * dispatchGetPostOrderAccepted
 * params
 * console.debug('dispatchGetPostOrderAccepted => ', orderDetails);
 *********************************************************************/
export const dispatchGetPostOrderAccepted = params => {
  const { dispatch, orderDetails, updateSetOrderDetails = null } = params;

  const request = {
    orderId: orderDetails?.orderId,
    tenantId: orderDetails?.tenantId,
    customerId: orderDetails?.customerId,
  };
  const count = orderDetails?.retryCountForGetOrderStatus + 1;
  dispatch(
    getPostOrderAccepted(request, () => getOrderDetailsSuccessCallback({ count, orderDetails, updateSetOrderDetails })),
  );
};

/*********************************************************************
 * dispatchPostAddHopePayment
 * params
 * console.debug('dispatchPostAddHopePayment => ', addHopeOrderDetails);
 *********************************************************************/
export const dispatchPostAddHopePayment = params => {
  if (isAddHopePurchase()) {
    const { dispatch, orderDetails, updateSetOrderDetails } = params;
    const request = {
      tenantId: orderDetails?.tenantId,
      miscPaymentReferenceId: orderDetails?.miscPaymentReferenceId,
    };
    const count = orderDetails?.retryCountForGetOrderStatus + 1;
    dispatch(
      getAddHopeOrderAccepted(request, () =>
        getOrderDetailsSuccessCallback({ count, orderDetails, updateSetOrderDetails }),
      ),
    );
  }
};

/*********************************************************************
 * dispatchPostGiftCardPayment
 * params
 * console.debug('dispatchPostGiftCardPayment => ', giftCardDetails);
 *********************************************************************/
export const dispatchPostGiftCardPayment = params => {
  if (isGiftCardPurchase()) {
    const { dispatch, orderDetails, updateSetOrderDetails } = params;
    const request = {
      tenantId: orderDetails?.tenantId,
      wiCodePurchaseId: orderDetails?.wiCodePurchaseId,
    };
    const count = orderDetails?.retryCountForGetOrderStatus + 1;
    dispatch(
      getGiftCardPurchaseAccepted(request, () =>
        getOrderDetailsSuccessCallback({ count, orderDetails, updateSetOrderDetails }),
      ),
    );
  }
};

/*********************************************************************
 * getOrderDetailsSuccessCallback
 * params
 * console.debug('getOrderDetailsSuccessCallback => ');
 *********************************************************************/
const getOrderDetailsSuccessCallback = params => {
  const { count, orderDetails, updateSetOrderDetails } = params;
  if (updateSetOrderDetails) {
    const dispatchGetOrderStatusTimer = setTimeout(() => {
      orderDetails?.dispatchGetOrderStatusTimer && clearTimeout(orderDetails?.dispatchGetOrderStatusTimer);
      updateSetOrderDetails({
        retryCountForGetOrderStatus: count,
        dispatchGetOrderStatusTimer: dispatchGetOrderStatusTimer,
      });
    }, config(GET_ORDER_STATUS_MAX_RETRY_INTERVAL_MS));
  }
};

/*********************************************************************
 * dispatchGetPostOrderAccepted
 * dispatch
 * console.debug('dispatchGetPostOrderAccepted => ');
 *********************************************************************/
export const dispatchGetTendersContent = dispatch => {
  dispatch(
    getTendersContent({
      object: getCmsClient(),
      contentFull: {
        content_type: 'tenders',
        include: 5,
        select: 'sys.id,fields',
      },
    }),
  );
};

/*********************************************************************
 * dispatchGetContentHelpCallAction
 * dispatch
 * console.debug('dispatchGetContentHelpCallAction => ');
 *********************************************************************/
export const dispatchGetContentHelpCallAction = dispatch => {
  dispatch(
    getContentHelpCall({
      object: getCmsClient(),
      contentFull: {
        content_type: 'staticLandingPage',
        'fields.page': 'Support Help',
        include: '5',
      },
    }),
  );
};

/*********************************************************************
 * dispatchGetBulkStoreStatusAction
 * params
 * console.debug('dispatchGetBulkStoreStatusAction => ');
 *********************************************************************/
export const dispatchGetBulkStoreStatusAction = params => {
  const { service, store, tenantId } = params?.orderDetails;
  const payload = [
    {
      storeId: store?.storeId,
      channel: ChannelManager.channel,
      service,
    },
  ];
  params?.dispatch(getBulkStoreStatus({ data: payload, tenantId, isFavoritePage: false }));
};

/*********************************************************************
 * resetReducers
 * params
 * console.debug('resetReducers => ');
 *********************************************************************/
export const resetReducers = params => {
  const { dispatch, beforeUnload = false, orderDetails = {} } = params;
  const { userStatus = {} } = orderDetails;
  const isCreateOrLoginKFCAccount = sessionStorage.getItem(SESSION_STORAGE_KEYS.ORDER_TRACKING_CLICK_KFC_ACCOUNT);

  if (
    (beforeUnload &&
      (window?.location?.pathname === ROUTE_URL?.ORDER_SUMMARY ||
        window?.location?.pathname === ROUTE_URL?.CHECKOUT)) ||
    isCreateOrLoginKFCAccount
  ) {
    return;
  }

  dispatch(resetPaymentStatus());
  if (localStorage?.getItem(LOCAL_STORAGE_KEYS?.PAYMENT_STATUS) !== PAYMENT_STATUS?.FAILED) {
    dispatch(resetPostOrder());
    dispatch(resetOrderAction());
  }
  dispatch(clearPastOrderAction({ value: [] }));

  if (
    window?.location?.pathname !== ROUTE_URL?.ORDER_SUMMARY ||
    userStatus?.loggedIn ||
    (!userStatus?.loggedIn &&
      window?.location?.pathname === ROUTE_URL?.ORDER_SUMMARY &&
      isOrderProcessCompleted(orderDetails))
  ) {
    sessionStorage?.removeItem(LOCAL_STORAGE_KEYS?.ORDER_TRACKING);
  }
};

/*********************************************************************
 * orderStatusChangeHandler
 * params
 * console.debug('orderStatusChangeHandler => ', orderDetails);
 *********************************************************************/
const checkPickupOrderCancelled = orderDetails =>
  isPickupOrderCancelled(orderDetails) && !orderDetails?.enableRetryCountForPickupOrderTracking;
const isFailedOrderCheck = orderDetails =>
  isFailedOrder(orderDetails) || isAddHopePaymentFailure(orderDetails) || isGiftCardPaymentFailure(orderDetails);
export const orderStatusChangeHandler = params => {
  const { orderDetails, updateSetOrderDetails } = params;

  const {
    props,
    service,
    displayOrderProcessingPage,
    retryCountForGetOrderTrackingStatus,
    orderAcceptedLoading,
    isBasketsCreated,
    customer,
    tenantId,
    userStatus,
  } = orderDetails;
  if (isValidOrderStatus(orderDetails) && !orderAcceptedLoading) {
    if (checkPickupOrderCancelled(orderDetails)) {
      sessionStorage.setItem(SESSION_STORAGE_KEYS.PICKUP_ORDER_CANCELLED, orderDetails.orderId);
      redirectToHomePage(props);
    } else if (isFailedOrderCheck(orderDetails)) {
      localStorage?.setItem(PAYMENT_STATUS?.STATUS_TEXT, PAYMENT_STATUS?.FAILED);
      redirectToPaymentFailurePage(props);
    } else {
      if (!orderDetails?.isExternalTrackOrder && !isBasketsCreated) {
        // check for invalidate cart for member user
        checkInvalidateCart(params);
      }
      if (
        displayOrderProcessingPage &&
        ((!isStagedOrAcceptedOrder(orderDetails) && !isAddHopePurchase() && !isGiftCardPurchase()) ||
          isAddHopePaymentSuccess(orderDetails) ||
          isGiftCardPaymentSuccess(orderDetails) ||
          (isCateringDisposition(service) && !isStagedOrder(orderDetails)))
      ) {
        updateSetOrderDetails({ displayOrderProcessingPage: false });
      }

      if (isCheckRetryCountForGetOrderTrackingStatus(orderDetails)) {
        updateSetOrderDetails({
          retryCountForGetOrderTrackingStatus: retryCountForGetOrderTrackingStatus + 1,
        });
      }
    }

    if (!userStatus?.loggedIn && !isAddHopePurchase() && !isGiftCardPurchase()) {
      updateOrderTrackingDetailsInLocalStorage({
        trackDetails: { customer, tenantId },
        orderDetails,
      });
    }
  }
};

/*********************************************************************
 * setLocalStorageDispositionNew
 * params
 * console.debug('setLocalStorageDispositionNew => ');
 *********************************************************************/
export const setLocalStorageDispositionNew = params => {
  const { orderDetails, dispositionPaymentPage, userOrderStateDispatch } = params;
  const details = {
    deliveryAddress: getFullAddressDetails(orderDetails?.deliveryAddress),
    store: orderDetails?.store,
    type: orderDetails?.service,
  };
  const dispositionNew = JSON?.parse(localStorage?.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW)) || {};
  dispositionNew.orderDetails = details;
  localStorage?.setItem(LOCAL_STORAGE_KEYS?.DISPOSITION_NEW, JSON?.stringify(dispositionNew));

  userOrderStateDispatch({
    type: START_ORDER_CONSTANTS?.SET_DISPOSITION_NEW,
    value: { dispositionNew: { ...dispositionPaymentPage, orderDetails: details } },
  });
};

/*********************************************************************
 * setLocalStorageDispositionNew
 * params
 * console.debug('setLocalStorageDispositionNew => ');
 *********************************************************************/
export const updateOrderTrackingDetailsInLocalStorage = params => {
  const { trackDetails, orderDetails, redirectTo, props } = params;
  const { customer, tenantId } = trackDetails;

  if (orderDetails?.id || orderDetails?.orderId) {
    const tempOrderDetails = orderDetails?.orderId
      ? { ...orderDetails, tenantId }
      : { ...getUpdatedOrderDetails({ postOrPastOrderDetails: { ...orderDetails }, customer }), tenantId };
    tempOrderDetails.postOrderDetails = {};
    tempOrderDetails.dispatch = null;
    tempOrderDetails.storesReducer = null;
    tempOrderDetails.additionalChargeLines = null;
    tempOrderDetails.additionalCharges = null;
    tempOrderDetails.filteredFoodLines = null;
    tempOrderDetails.foodLines = null;
    tempOrderDetails.operatingTime = null;
    tempOrderDetails.operatingTimeFromStoreReducer = null;
    tempOrderDetails.props = null;

    sessionStorage.setItem(LOCAL_STORAGE_KEYS?.ORDER_TRACKING, JSON.stringify(tempOrderDetails));

    if (redirectTo) {
      redirectTo(props);
    }
  } else {
    console.error(JSON.stringify(orderDetails));
    redirectToPaymentFailurePage(props);
  }
};

/*********************************************************************
 * dispatchPickupOrderCancelPostOrderAction
 * params
 * console.debug('dispatchPickupOrderCancelPostOrderAction => ');
 *********************************************************************/
export const dispatchPickupOrderCancelPostOrderAction = params => {
  const { dispatch, orderDetails, updateSetOrderDetails } = params;
  const { orderId, customerId, tenantId } = orderDetails;
  const payload = {
    orderId,
    tenantId,
    customerId,
    paramData: {
      reason: 'default',
      channel: 'web',
      isRefundable: false,
    },
  };
  dispatch(
    cancelPostOrder(
      payload,
      () => {
        updateSetOrderDetails({ isShowPickupOrderCancelModal: false, pickupCancelOrder: false });
        sessionStorage?.removeItem(LOCAL_STORAGE_KEYS?.ORDER_TRACKING);
        dispatchGetOrderDetailsAction({ dispatch, orderDetails, updateSetOrderDetails });
      },
      () => updateSetOrderDetails({ isShowPickupOrderCancelModal: false, pickupCancelOrder: false }),
    ),
  );
};

/*********************************************************************
 * dispatchPickupOrderCheckInRequestAction
 * params
 * console.debug('dispatchPickupOrderCheckInRequestAction => ');
 *********************************************************************/
export const dispatchPickupOrderCheckInRequestAction = params => {
  const { dispatch, orderDetails, updateSetOrderDetails } = params;
  const {
    orderId,
    customerId,
    tenantId,
    selectedPickupOrderCollectionMethod,
    collectionPoint: { carNumber = null } = {},
  } = orderDetails;
  const payload = {
    orderId,
    tenantId,
    customerId,
    paramData: {
      name: selectedPickupOrderCollectionMethod,
      bayNumber: 0,
      checkInSummary: '',
      carNumber,
    },
  };
  const callback = () =>
    updateSetOrderDetails({
      isShowPickupOrderCheckReadyToPrepareModal: false,
      isPickupOrderUserConfirmedToCheckIn: false,
    });
  dispatch(checkInRequest(payload), callback, callback);
};

/*********************************************************************
 * checkOrderProcessdetails
 * params
 *
 *********************************************************************/
export const checkOrderProcessdetails = params => {
  const { orderReducer, paymentsContentReducer, orderDetails, updateSetOrderDetails, props } = params;

  if (orderReducer?.response?.order?.id) {
    if (orderReducer?.response?.order?.tenders?.length === 0) {
      redirectToCARTPage(props);
    } else {
      updateOrderDetailsFromCreateOrderReducer({
        orderReducer,
        paymentsContentReducer,
        orderDetails,
        updateSetOrderDetails,
      });
    }
  }
};
export const updateStoreTimings = (storesReducer,orderDetails,updateSetOrderDetails) =>{
  const currentStoresDetails = storesReducer?.storesWithStatus?.length ? storesReducer?.storesWithStatus?.[0] : {};
  orderDetails?.store?.timings && updateSetOrderDetails({store:{...orderDetails?.store,...currentStoresDetails?.summary}})
}
